/** Expense claims awaiting approval for the "Coming up" list. The caller passes
 *  a workspace only for workspace owners and admins, the people who can approve.
 *  Any failure just means no rows. Refetches when the date changes so a claim
 *  crossing the waiting threshold appears on a dashboard left open overnight. */

import { useEffect, useMemo, useState } from 'react';
import type { ExpenseClaim } from '../../types/accounting';
import { useBackgroundRead } from '../../hooks/useBackgroundRead';
import { londonDayKey, submittedExpenseClaimsRead } from './homeComingUpReads';

const DAY_CHECK_MS = 5 * 60_000;
const NONE: readonly ExpenseClaim[] = [];

export function useSubmittedExpenseClaims(workspaceId: string | undefined): readonly ExpenseClaim[] {
  const [dayKey, setDayKey] = useState(londonDayKey);

  useEffect(() => {
    const id = window.setInterval(() => setDayKey(londonDayKey()), DAY_CHECK_MS);
    return () => window.clearInterval(id);
  }, []);

  const read = useMemo(() => (workspaceId ? submittedExpenseClaimsRead(workspaceId) : null), [workspaceId]);
  return useBackgroundRead(workspaceId, read, { refreshKey: dayKey }) ?? NONE;
}
